export const AUTH_TOKEN = 'meshifySlimToken'
export const AUTH_TOKEN_VALUE = 'meshify-authenticated'
export const LOGOUT_TOKEN = 'logged-out'
export const MESHIFYID_TOKEN = 'meshifyId'
export const SIDEWALKID_TOKEN = 'sidewalkId'

export const VERIFY_FOLDER_ID = 'VERIFY_FOLDER_ID'
export const VERIFY_NODE_ID = 'VERIFY_NODE_ID'

export const SHORT_SCREEN_HEIGHT = '667px'
